import { render, staticRenderFns } from "./SvSelectList.vue?vue&type=template&id=2c1a1c40&scoped=true&lang=pug&"
import script from "./SvSelectList.vue?vue&type=script&lang=js&"
export * from "./SvSelectList.vue?vue&type=script&lang=js&"
import style0 from "./SvSelectList.vue?vue&type=style&index=0&id=2c1a1c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1a1c40",
  null
  
)

export default component.exports